import { IImageDetails } from '../interfaces/image-details.interface';
import { IImageInfo } from '../interfaces/image-info.interface';

export class ImageInfo {
  private images: IImageInfo = {};

  constructor(initialData: IImageInfo = {}) {
    this.images = initialData;
  }

  getImageDetails(placeId: string): IImageDetails | undefined {
    return this.images[placeId];
  }

  addImage(imageDetails: IImageDetails): void {
    this.images[imageDetails.country_id] = imageDetails;
  }

  removeImage(placeId: string): void {
    delete this.images[placeId];
  }

  getFirstImage(): IImageDetails | undefined {
    const firstKey = Object.keys(this.images)[0];
    return firstKey ? this.images[firstKey] : undefined;
  }
}
